import { render, staticRenderFns } from "./details.vue?vue&type=template&id=0e1c006e&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=0e1c006e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c006e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BargainSteps: require('/drone/src/components/Bargain/steps/index.vue').default,TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default})
